// extracted by mini-css-extract-plugin
module.exports = {"radioBox":"styles_radioBox__2ttX1","checkboxWrapper":"styles_checkboxWrapper__m6jjK"};